export const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const PaymentStatus = {
  INITIAL: 'initial',
  PENDING: 'pending',
  SUCCESSFUL: 'successful',
  FAILED: 'failed',
};

const ADULT_TICKET_TYPE = 'adult';
const CHILD_TICKET_TYPE = 'child';
const INFANT_TICKET_TYPE = 'infant';

export const TICKET_TYPES = {
  Adult: ADULT_TICKET_TYPE,
  Child: CHILD_TICKET_TYPE,
  Infant: INFANT_TICKET_TYPE,
};

export const TICKET_TYPES_ORDERED = [TICKET_TYPES.Adult, TICKET_TYPES.Child, TICKET_TYPES.Infant];

export const PaymentStatuses = Object.values(PaymentStatus);

export const JUDO_REQUEST_TIMEOUT = 10000;
